export const selectCurrency = (state) => state.currency;
export const selectChannel = (state) => state.channel;